import React from 'react';

import { StyledGatsbyImage, StyledSvg } from './EmbeddedAssetImageStyles';

/**
 * Render embedded image in rich text
 *
 * @param {ContentfulAsset} image
 *
 * @returns {React.ReactElement}
 */
function EmbeddedAssetImage({ image }) {
  if (!image) return null;

  return image.gatsbyImageData ? (
    <StyledGatsbyImage image={image.gatsbyImageData} alt={image.title || ''} />
  ) : (
    <StyledSvg src={image.file?.url} alt={image.title || ''} loading="lazy" />
  );
}

export default EmbeddedAssetImage;
